// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"EditInvitationModal_modalBody_2x0DH"};